import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "control-panel-container",
    title: "CONTROL PANEL"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_GenericButton, {
          onClick: _ctx.resetBuild,
          text: "NEW CHARACTER",
          "full-height": ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_GenericButton, {
          onClick: _ctx.toggleSaveMenu,
          text: "SAVE CHARACTER",
          "is-disabled": _ctx.disableSave,
          "full-height": ""
        }, null, 8, ["onClick", "is-disabled"]),
        _createVNode(_component_GenericButton, {
          onClick: _ctx.toggleLoadMenu,
          text: "LIBRARY",
          "full-height": ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_GenericButton, {
          onClick: _ctx.toggleInventoryMenu,
          text: "INVENTORY",
          "full-height": ""
        }, null, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}